import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_PATCH } from '../../constants/api';

const patchUserRole = createAsyncThunk('users/patchUserRole',
  async ({ userId, roleId }, { rejectWithValue }) => {
    try {
      await authSet(METHOD_PATCH, `/users/${userId}/role`, { role_id: roleId });
      return true;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default patchUserRole;
